angular.module('app').factory('AgGridOverlayService', function () {
    let fac = {
        loading: loading,
        noRows: noRows
    };
    function loading(msg) {
        return `<span class="ag-overlay-loading-center">${msg}</span>`;
    }
    function noRows(msg) {
        return `<span class="ag-overlay-no-rows-center">${msg}</span>`;
    }
    return fac;
});
